import React from 'react';

import * as styles from './MoreSpeakersCard.module.scss';

export default function MoreSpeakersCard({ title, description, theme = 'regular' }) {
  return (
    <div className={styles[theme]}>
      <p className={styles.title}>{title}</p>
      <p className={styles.description}>{description}</p>
    </div>
  );
}
